export enum SkeletonType {
  avatar = 'avatar',
  text = 'text',
  image = 'image',
  card = 'card'
}
